// (function () {
//     'use strict';

//     angular.module("imApp").factory("selectProductService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getSetting: function (parms) {
//                 return $ihttp.post({
//                     method: 1296,
//                     parameters: parms || {}
//                 });
//             },
//             listComponentProducts: function (parms) {
//                 return $ihttp.post({
//                     method: 390,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
